import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TntToolService, TntToolOwnerService } from '../../tnt.service';
import { UserService, ModuleService } from '../../../mesc/mesc.service';
import { ToolOwner } from '../../../../shared/model';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';

@Component({
  selector: 'app-tool-ownership',
  templateUrl: './tool-ownership.component.html',
  host: { 'style': 'width: 100%' },
})
export class ToolOwnershipComponent implements OnInit {



  constructor(
    private TntToolOwnerService: TntToolOwnerService,
    private TntToolService: TntToolService,
    private FormBuilder: FormBuilder,
    private CgpAlertDialogService: CgpAlertDialogService,
    private CgpSnackbarService: CgpSnackbarService,
    public UserService: UserService,
    private ModuleService: ModuleService,


  ) {

  }

  selectedRows: any[];
  isNew: boolean = false;
  editDataItem: ToolOwner;
  ModuleTypeId: any;
  SelectedFromOwner: any;
  SelectedToOwner: any;

  fromOwnerFilter: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  toOwnerFilter: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);


  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  editForm = this.FormBuilder.group({
    Ownername: [],
    ToolNumber: [],
    ToolDescription: [],
    OwnerGmin: [],
    FromOwnerGmin: [],
    ToOwnerGmin: [],
    ModuleTypeId: [],



  });


  columns = [
    {
      field: 'ToolNumber',
      title: 'Tool Number',
    },
    {
      field: 'ToolDescription',
      title: 'Description',
    }
  ]


  Owner: Array<ToolOwner>;

  ngOnInit() {

    return this.ModuleService.read("", true)
      .then((ModuleTypes: any) => {
        let ModuleTypeId = ModuleTypes.find(function (ModuleType) {
          return ModuleType.Name === "TNTS";
        }).Id;

        this.UserService.read("/module/" + ModuleTypeId, true)
          .then(data => {
            let TntData: any[] = data.TntTools ? data.TntTools : data
            TntData.map(x => x.cn = x.FirstName + ' ' + x.LastName);
            TntData.sort(this.compare);
            this.fromOwnerFilter.next(TntData);
            this.toOwnerFilter.next(TntData);
            return TntData;
          });

      })
  }

  private compare(a, b): number {
    try {
      let check1: string = a.LastName.toLowerCase(), check2 = b.LastName.toLowerCase();
      return check1 > check2 ? 1 : check1 < check2 ? -1 : 0;
    } catch (e) {
      return 0;
    }
  }

  private parseselectedRows(): any[] {
    return this.selectedRows.map(x => x.dataItem.Id);
  }

  handletransfer = () => {
    let data2 = this.parseselectedRows()
    var self = this;
    let gmin = this.SelectedToOwner.GMIN ? this.SelectedToOwner.GMIN : this.SelectedToOwner;
    self.TntToolService.save(data2, false, '/transferowner?toUserGmin=' + gmin, false, false, false)
      .then(function () {
        self.CgpAlertDialogService.showAlertDialog({
          title: 'Confirmation',
          message: 'Tool(s) has been transfered ',
          alert: '',
          closeLabel: 'Close',

        })
        self.grid.refresh(true);
        self.CgpSnackbarService.showSnackbar({
          message: "Record has been updated",
          duration: 2000
        })
      });

  };



  handleread = () => {
    if (this.SelectedFromOwner)
      return this.TntToolOwnerService.read("/" + this.SelectedFromOwner.GMIN + "/" + "tool", true)
    else
      return Promise.resolve([])
    // this.refresh(true);

  }

  handlereadModule = () => {

    var self = this;

    return this.ModuleService.read("", true).then(function (ModuleTypes: any) {
      self.ModuleTypeId = ModuleTypes.Items.Find(function (ModuleType) {
        return ModuleType.Description === "TNTS";
      }).Id;

    })
  }

  handleControlDisabled = (id): boolean => {
    switch (id) {
      case 'transferTool':
        return !this.SelectedFromOwner || !this.SelectedToOwner;
      default:
        break;
    }
  }


  handleSelect = (selected: any[]) => {
    this.selectedRows = selected;

  }


  setModelHandler(): void {
    this.editDataItem = new ToolOwner();
    this.editDataItem.ModuleTypeId = this.ModuleTypeId

  }

  handleValueChangeFROM(e: any) {
    var self = this;
    // this.editDataItem = e;
    this.SelectedFromOwner = e;
    if (e && this.SelectedToOwner) self.grid.refresh(true);
  }



  handleValueChangeTO(e: any) {
    var self = this;
    this.SelectedToOwner = e;
    if (e && this.SelectedFromOwner) self.grid.refresh(true);
    // this.editDataItem = e ? e.GMIN : undefined;
  }


  handleFilter(value: any, from: boolean = false) {
    let check: string = value.toString();
    let result = this.UserService.value.filter(x => {
      try {
        let source: string = x['cn'].toString().toLowerCase();
        return source.indexOf(check.toLowerCase()) !== -1;
      } catch (e) { }
    });
    from ?
      this.fromOwnerFilter.next(result)
      :
      this.toOwnerFilter.next(result);
  }



  TransferTemplateControl = {
    id: "transferTool",
    iconClass: "fa fa-random",
    title: "Transfer tool Ownership",
    text: "Transfer tool Ownership",
    callback: this.handletransfer,
  }

  template = {
    title: "TNTS Tools",
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: false,
      width: 10,
      customToolbar: [
        this.TransferTemplateControl,
      ],
      isDisabled: this.handleControlDisabled,
    },
    selectable: true,
    columns: this.columns,
    read: this.handleread,
    service: this.TntToolOwnerService,
    refresh: true,
    callback: this.handleread,

    select: this.handleSelect,
  }





}
